import { put, call, takeLatest } from 'redux-saga/effects';
import { actions } from './Reducer';
import {
  setSupplierProductsIsLoadingAction,
  getSupplierProductsSuccessAction,
  createSupplierProductSuccessAction,
  setSupplierProductsCountAction,
  updateSupplierProductSuccessAction,
  getSupplierProductSuccessAction,
} from './Actions';
import {
  newSuccessNotificationAction,
  errorNotificationFromError,
} from '../notifications/Actions';
import * as api from './Api';
import { push } from 'connected-react-router';

function* createSupplierProduct({ payload }) {
  try {
    yield put(setSupplierProductsIsLoadingAction(true));
    const response = yield call(api.createSupplierProduct, payload);
    const { data } = response;
    const product = data;
    yield put(newSuccessNotificationAction(`Product Created !`));
    yield put(createSupplierProductSuccessAction(product));
    yield put(push('/supplier-products'));
  } catch (error) {
    yield put(errorNotificationFromError(error));
  } finally {
    yield put(setSupplierProductsIsLoadingAction(false));
  }
}

function* updateSupplierProduct({ payload }) {
  const { id, formData } = payload;

  try {
    yield put(setSupplierProductsIsLoadingAction(true));
    const response = yield call(api.updateSupplierProduct, id, formData);
    const { data } = response;
    const product = data;

    yield put(newSuccessNotificationAction(`Product Updated !`));
    yield put(updateSupplierProductSuccessAction(product));
    yield put(push('/supplier-products'));
  } catch (error) {
    yield put(errorNotificationFromError(error));
  } finally {
    yield put(setSupplierProductsIsLoadingAction(false));
  }
}

function* getSupplierProduct({ payload }) {
  const id = payload;

  try {
    yield put(setSupplierProductsIsLoadingAction(true));
    const response = yield call(api.getSupplierProduct, id);
    const { data } = response;
    const product = data;
    yield put(getSupplierProductSuccessAction(product));
  } catch (error) {
    yield put(errorNotificationFromError(error));
  } finally {
    yield put(setSupplierProductsIsLoadingAction(false));
  }
}

function* getSupplierProducts({ payload }) {
  const defData = {
    offset: 0,
    size: 10,
    searchTerm: '',
    filterBy: [{}],
    filterCountry: '',
    sort: 'name',
    dir: 'asc',
  };

  const body = { ...defData, ...payload };

  try {
    yield put(setSupplierProductsIsLoadingAction(true));
    const response = yield call(api.getSupplierProducts, body);
    const { content, count } = response.data;
    yield put(setSupplierProductsCountAction(count));
    yield put(getSupplierProductsSuccessAction(content));
  } catch (error) {
    yield put(errorNotificationFromError(error));
  } finally {
    yield put(setSupplierProductsIsLoadingAction(false));
  }
}

function* getSupplierProductsPicutres({ payload }) {
  try {
    yield put(setSupplierProductsIsLoadingAction(true));
    const response = yield call(api.getSupplierProductsPictures);
    const { data } = response;
    yield put(getSupplierProductSuccessAction(data));
  } catch (error) {
    yield put(errorNotificationFromError(error));
  } finally {
    yield put(setSupplierProductsIsLoadingAction(false));
  }
}

function* addEditorReview({ payload }) {
  const { id, formData } = payload;
  try {
    yield put(setSupplierProductsIsLoadingAction(true));
    const response = yield call(api.addEditorsReview, id, formData);
    const { data } = response;
    yield put(updateSupplierProductSuccessAction(data));
    yield put(newSuccessNotificationAction('Thanks for Your Review'));
  } catch (error) {
  } finally {
    yield put(setSupplierProductsIsLoadingAction(false));
  }
}

export default function*() {
  yield takeLatest(actions.GET_SUPPLIER_PRODUCTS, getSupplierProducts);
  yield takeLatest(actions.CREATE_SUPPLIER_PRODUCT, createSupplierProduct);
  yield takeLatest(actions.GET_SUPPLIER_PRODUCT, getSupplierProduct);
  yield takeLatest(actions.UPDATE_SUPPLIER_PRODUCT, updateSupplierProduct);
  yield takeLatest(
    actions.GET_SUPPLIER_PRODUCTS_PICTURES,
    getSupplierProductsPicutres
  );
  yield takeLatest(actions.ADD_EDITOR_REVIEW_SUPPIER_PRODUCT, addEditorReview);
}
